/* eslint-disable @typescript-eslint/no-unused-vars */
import createActions from '../../config/actions/createActions';
import { action } from '@play-co/replicant';
import { shopBundlesClaimProductRewards } from './match2-shopbundles.modifiers';
import { ProductId } from 'src/replicant/iap';

/** Development mode only, not allowed in production */
export const match2ShopBundlesCheats = createActions({
  /**
   * Reset shop bundles, making items available for purchase again
   */
  cheat_shopBundlesReset: action((state, _: void, api) => {
    // Also reset the pet starterpack promo
    if (state.promo.petStarterPack) {
      delete state.promo.petStarterPack;
    }
    delete state.match2.shopBundles;
  }),

  /**
   * Clear all powerups and boosters
   */
  cheat_shopBundlesClearPowerups: action((state, _: void, api) => {
    state.match2.powerups = {
      bomb: 0,
      rocket: 0,
      cube: 0,
    };
    state.match2.boosters = {
      dart: 0,
      bullet: 0,
      drill: 0,
      roulette: 0,
    };
  }),
});
